export default "__VITE_ASSET__CEOjgFT3__"